import { useEffect, useState } from "react"

/**
 * The current epoch ms, re-rendering every `intervalMs`. Backs the live
 * "Next check-in" countdown on the Checker/Convoy trip cards, so it counts
 * down in real time instead of showing a single value frozen at whenever
 * the trip list was last fetched -- same ticking-clock pattern the Android
 * app's ActiveTripCard/ConvoyTripCard use.
 *
 * @param {number} [intervalMs]
 * @returns {number}
 */
export function useTickingClock(intervalMs = 1000) {
    const [now, setNow] = useState(() => Date.now())

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), intervalMs)
        return () => clearInterval(id)
    }, [intervalMs])

    return now
}
